<!-- 
	author:lgy
	通用组件：顶部欢迎标语及注册登录按钮导航条 
-->
<template>
	<div class="header_top">
		<div class="headCenter">
			<!-- 左侧欢迎标语 -->
			<div class="header_top_left">
				<span>您好，欢迎访问易知网！</span>
			</div>
			<!-- 右侧注册登录标签 -->
			<div class="header_top_right" v-if="!token">
				<span class="login_title" @click="login">
					登录 
				</span>
				|
				<span class="register_title" @click="register">
					注册
				</span>
			</div>
			<!-- 如果已登录 -->
			<div v-else class="isLogin">
				<span>
					{{user.phone}}
				</span>
				|
				<span @click="goPersonal">
					个人中心
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	export default{
		data(){
			return{
				user:JSON.parse(window.sessionStorage.getItem('user')),
				token:window.sessionStorage.getItem('token')
			}
		},
		mounted() {
			
		},
		methods: {
			login(){
				this.$router.push('/login')
			},
			goPersonal(){
			    this.$router.push('/personal')
			},
			register(){
				this.$router.push({
				  path:'/login',
				  query:{
				   isReg:'true'
				  }
				})
			}
		},
	}
</script>

<style scoped>
	.header_top{
		width: 100%;
		background-color: #f1f1f1;
		height: 32px;
		color: #999;
	}
	.headCenter{
		width: 1200px;
		height: 32px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.header_top_right .login_title:hover,
	.header_top_right .register_title:hover,
	.isLogin span:hover{
		cursor: pointer;
		color:#C32A1A;
	}
</style>
